var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationBuildingSearch = function SvgLocationBuildingSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12M10.74 10.74l2.76 2.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.25 6.5 3l2.75 2.25V8a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1z"
  }))));
};
export default SvgLocationBuildingSearch;